/*
 Created by qing 2020/2/8 8:25 下午
 */


export const SUCCESS = 0
export const ERROR = -1
export const DECODE_ERROR = -2

export const COMPANY_NOT_EXIST_ERROR = 50030008 // 公司信息不存在

export const LINK_POSTING_PASSWORD_ERROR = 500160002 // 外链密码错误
export const LINK_POSTING_FORIF = 500160001 // 外链不存在或者已关闭

export const FLOW_FORM_NOT_EXIST = 50040007 // 表单不存在
export const FORM_PREVIEW_NOT_EXIST_ERROR = 50040035 // 表单预览信息不存在

export const APP_FORM_FLOW_NOT_INIT_ERROR = 50040005  // 表单流程尚未初始化

export const ENV_TYPE_WXWORK = 'wxwork' // 企业微信环境
export const ENV_TYPE_WXWORK_ZJ = 'wxwork_zj' // 企业微信环境
export const ENV_TYPE_SMALLPROGRAM = 'smallProgram' // 微信小程序环境
export const ENV_TYPE_LARK_MINI_PROGRAM = 'lark_miniProgram' // 飞书小程序环境
export const ENV_TYPE_LARK_H5 = 'lark_h5' // 飞书小程序环境
export const ENV_TYPE_SPACE = 'space' // 客户门户
export const ENV_TYPE_DINGTALK = 'dingtalk' // 企业微信环境
export const ENV_TYPE_DINGTALK_ZJ = 'dingtalk_zj' // 企业微信环境

// 加密类型
export const ENCODE_TYPE_ZEUS = 'ZEUS' // AES(HEX)加密

export const DASHBOARD_DATA_SOURCE_EXIST = 500270001; // 表结构中不存在该控件

//------ 融合表挂载类型
export const MIX_FORM_ITEM_TYPE_NODE = 'NODE' // 下级目录
export const MIX_FORM_ITEM_TYPE_MIX_FORM = 'MIX_FORM' // 融合表
export const MIX_FORM_ITEM_TYPE_ATTACHMENT = 'ATTACHMENT' // 附件
export const MIX_FORM_ITEM_TYPE_IMAGE = 'IMAGE' // 图片附件
export const MIX_FORM_ITEM_TYPE_MEMO = 'MEMO' // 备忘录
export const MIX_FORM_ITEM_TYPE_DATA = 'DATA' // 表单数据
export const MIX_FORM_ITEM_TYPE_VIEW = 'VIEW' // 表单视图
export const MIX_FORM_ITEM_TYPE_TODO = 'TODO' // 待办视图
export const MIX_FORM_ITEM_TYPE_DASHBOARD = 'DASHBOARD' // 仪表盘
export const MIX_FORM_ITEM_TYPE_APPLY = 'APPLY' // 发起表单